import { type GuestUserParams } from '@/features/account/services/GuestUser/types'

export const EMPTY_GUEST_PARAMS: GuestUserParams = {
  guestStore: undefined,
  guestAddress: undefined,
}

export const GUEST_PARAMS_QUERY_KEY = ['guestUser'] as const
